import { Component, Input, OnInit } from '@angular/core';

import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';
import { TextColorEnum } from '~/cms/enums/text-color.enum';
import { ImageCms } from '~/cms/interfaces/homepage.cms.interface';
import { BackLinkVariantEnum } from '~/component/back-link/enums/back-link-variant.enum';
import { BreakpointWidthEnum } from '~/core/enums/breakpoint-width.enum';

import { JumbotronVariantEnum } from './enums/jumbotron-variant.enum';

@Component({
  selector: 'app-attendee-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.scss'],
})
export class AttendeeJumbotronComponent implements OnInit {
  @Input() public backLink?: BackLinkInterface;
  @Input() public backLinkAriaLabel?: string;
  @Input() public description?: string;
  @Input() public imgDesktop: ImageCms;
  @Input() public imgMobile: ImageCms;
  @Input() public textColor: TextColorEnum;
  @Input() public title: string;
  @Input() public variant = JumbotronVariantEnum.Default;
  @Input() public isHp?: boolean;
  public backLinkStyle = BackLinkVariantEnum.Default;

  public ngOnInit(): void {
    if (this.variant === JumbotronVariantEnum.FullWidthImage) {
      this.backLinkStyle = BackLinkVariantEnum.White;
    }
  }

  public get jumbotronClasses(): string[] {
    let variantClass = '';
    const colorClass = this.textColor ? `jumbotron--${this.textColor}` : '';

    switch (this.variant) {
      case JumbotronVariantEnum.FullWidthImage:
        variantClass = 'jumbotron--full-width-image';
        break;

      case JumbotronVariantEnum.Rounded:
        variantClass = 'jumbotron--rounded-image';
        break;

      case JumbotronVariantEnum.WithoutPicture:
        variantClass = 'jumbotron--without-picture';
        break;
    }

    return [variantClass, colorClass];
  }

  public get mediaMediumBreakpoint(): string {
    return `(min-width: ${BreakpointWidthEnum.MD}px)`;
  }
}
